export default __webpack_public_path__ + "static/media/6.3e2d751c.png";